import React from "react"

import { ScheduleProvider } from "@shared/contexts"
import { useCriteo, useCRM } from "@shared/hooks"

import { StockCounsels } from "stockCounsels/components"

function StockCounselPage() {
  useCriteo()
  useCRM()

  return <StockCounsels />
}

export default () => (
  <ScheduleProvider isDetect={false}>
    <StockCounselPage />
  </ScheduleProvider>
)
